import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { filterAllTruthyInTuple } from 'core/rx-js';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { IColumn } from '../data-grid.component';
import { DataGridService } from '../data-grid.service';

@Component({
  selector: 'ss-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellComponent {

  readonly columnSubject = new BehaviorSubject<IColumn>(null)
  @Input() get column() {
    return this.columnSubject.value
  }
  set column(value) {
    this.columnSubject.next(value)
  }

  @Input()
  isTitle: boolean

  readonly valueSubject = new BehaviorSubject<string>(null)
  @Input() get value() {
    return this.valueSubject.value
  }
  set value(value) {
    this.valueSubject.next(value)
  }


  readonly searchSubject = this._dataGridService.searchSubject;

  readonly searchSplitArrayObs = combineLatest([
    this.searchSubject,
    this.valueSubject,
    this.columnSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      map(([search, value, column]) =>
        column.type === 'string' ? this.customSplit(value, search) : [value]
      ),
    )

  constructor(
    private readonly _dataGridService: DataGridService
  ) {
  }


  customSplit(value: string, splitter: string): string[] {

    const idx = value.toLowerCase().indexOf(splitter.toLowerCase());

    if (idx === -1) {
      return [value]
    }

    const prev = value.substring(0, idx);
    const found = value.substring(idx, splitter.length + idx);
    const next = value.substring(idx + splitter.length)

    return [prev, found, ...this.customSplit(next, splitter)];
  }

}
